export default "__VITE_ASSET__BFGmLPZW__"